<template>
  <div class="about">
    <h2 :class="`d-flex justify-center`" v-if="!isForgotAC">OR</h2>
    <hr />
    <div :class="`d-flex justify-center`">
      <!-- <h3>If you are a new user - activate your account here:</h3> -->
      <div class="pa-md-4">
        <v-card elevation="4">
          <v-card-title v-if="isForgotAC">Enter ProfileKey</v-card-title>
          <v-card-title v-if="!isForgotAC">Activate Account</v-card-title>
          <v-card-subtitle v-if="!isForgotAC"
            >As a new user you need to activate your account before you can use
            it.</v-card-subtitle
          >
          <v-card-text>
            Use the ProfileKey you have received by email or sms.</v-card-text
          >
          <div class="pa-md-4">
            <v-text-field
              v-model="profileKey"
              label="ProfileKey"
              outlined
              clearable
              hint="Example: AB01FC98BD4862AA9995BB"
              style="max-width: 300px"
              class="mx-auto"
              :rules="pkRules"
              maxlength="20"
            ></v-text-field>
          </div>
          <v-card-actions>
            <v-btn
              class="mx-auto"
              color="primary"
              :to="profilePath + profileKey"
              :disabled="profileKey.length < 20"
              @click="onOkClick"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
        <!-- :disabled="profileKey == null || profileKey == ''" -->
        <!-- <pre>{{ profilePath }}{{ profileKey }}</pre> -->
      </div>
    </div>
    <!-- <div :class="`d-flex justify-space-around mb-6`">
      <v-btn color="primary" :to="{ name: 'LogIn'}"
        >Go to Log In <v-icon right small>fa-key</v-icon>
      </v-btn>
    </div> -->
    <!-- <pre>{{ profileKey.length }}</pre> -->
  </div>
</template>

<script>
// @ is an alias to /src
// 55A1D3737D894706B4B4
export default {
  data() {
    return {
      profileKey: "",
      disabled: true,
      profilePath: "/profile/",
      pkRules: [
        (v) => !!v || "Key is required.",
        (v) => (v && v.length > 19) || "Must be 20 characters",
        (v) =>
          /^[0-9a-fA-F]+$/.test(v) ||
          "Code must be valid. Only letters og digits",
      ],
      isForgotAC: false,
    };
  },
  methods: {
    onOkClick() {
      console.log("", this.profileKey);
    },
  },
};
</script>

